import {
  GET_CHECKLIST,
  GET_CHECKLIST_SUCCESS,
  GET_CHECKLIST_FAIL,
  ADD_CHECKLIST,
  ADD_CHECKLIST_SUCCESS,
  ADD_CHECKLIST_FAIL,
  UPDATE_CHECKLIST,
  UPDATE_CHECKLIST_SUCCESS,
  UPDATE_CHECKLIST_FAIL,
  DELETE_CHECKLIST,
  DELETE_CHECKLIST_SUCCESS,
  DELETE_CHECKLIST_FAIL,
  SET_CHECKLIST_FIELD_ERRORS,
} from './actionTypes'

const initialState = {
  checklist: [],
  loading: false,
  error: null,
  status: null,
  fieldErrors: {}, // Store field-specific errors
}

const checklistReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CHECKLIST:
      return { ...state, loading: true }
    case GET_CHECKLIST_SUCCESS:
      return { ...state, loading: false, checklist: action.payload }
    case GET_CHECKLIST_FAIL:
      return { ...state, loading: false, error: action.payload }

    case ADD_CHECKLIST:
      return { ...state, loading: true }
    case ADD_CHECKLIST_SUCCESS:
      return { ...state, loading: false, status: 'success', fieldErrors: {} } // Clear field errors on success
    case ADD_CHECKLIST_FAIL:
      return { ...state, loading: false, error: action.payload }

    case UPDATE_CHECKLIST:
      return { ...state, loading: true }
    case UPDATE_CHECKLIST_SUCCESS:
      return {
        ...state,
        loading: false,
        fieldErrors: {}, // Clear field errors on success
      }
    case UPDATE_CHECKLIST_FAIL:
      return { ...state, loading: false, error: action.payload }

    case DELETE_CHECKLIST:
      return { ...state, loading: true }
    case DELETE_CHECKLIST_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case DELETE_CHECKLIST_FAIL:
      return { ...state, loading: false, error: action.payload }

    case SET_CHECKLIST_FIELD_ERRORS:
      return { ...state, fieldErrors: action.payload }

    default:
      return state
  }
}

export default checklistReducer
